import { useSelector } from 'react-redux';

import {
  getKnmIsCommonWatchOnly,
  getKnmIsEditableInStatusCommentsExist,
  getKnmIsErknmStatusCommentsExist,
  getKnmIsErknmStatusFillInProcess,
  getKnmIsErknmStatusReadyForApprove,
  getKnmIsErpStatusTypeWaitingCarryOut,
} from '../../../KnmPackage/MainModule/selectors/knmSelectors';
import { getPlanListPlanErknmStatus } from '../../../PlanListPackage/MainModule/selectors/planListSelectors';
import { getIsPlanErknmStatusConsidered } from '../../../APIPackage/PlanListModule/common/getPlanErknmStatusFlags';
import { getUserRoleIsSupervisor } from '../../../AuthPackage/MainModule/selectors/authSelectors';
import { useHasFieldApproveRemark } from '../common/useHasFieldApproveRemark';
import { ErknmApproveRemarkSectionCodeEnum } from '../../ErknmApproveRemarkModule/enums/ErknmApproveRemarkSectionCodeEnum';

export const isCollaboratingOrganizationsEnabled = (): boolean => {
  const isEditableInStatusCommentsExist = useSelector(getKnmIsEditableInStatusCommentsExist);
  const knmPlanStatus = useSelector(getPlanListPlanErknmStatus);
  const isKnmPlanStatusConsideration = getIsPlanErknmStatusConsidered(knmPlanStatus);
  const isSupervisor = useSelector(getUserRoleIsSupervisor);
  const isCommonWatchOnly = useSelector(getKnmIsCommonWatchOnly);
  const isKnmStatusFillInProcess = useSelector(getKnmIsErknmStatusFillInProcess);
  const isKnmStatusReadyForApprove = useSelector(getKnmIsErknmStatusReadyForApprove);
  const isKnmStatusTypeWaitingCarryOut = useSelector(getKnmIsErpStatusTypeWaitingCarryOut);
  const isKnmStatusCommentsExist = useSelector(getKnmIsErknmStatusCommentsExist);
  const isRemarksExists = useHasFieldApproveRemark(ErknmApproveRemarkSectionCodeEnum.COLLABORATING_ORGANIZATIONS);

  return (
    !isCommonWatchOnly &&
    isSupervisor &&
    (isEditableInStatusCommentsExist ||
      isKnmStatusFillInProcess ||
      isKnmStatusReadyForApprove ||
      (isKnmStatusCommentsExist && isRemarksExists) ||
      (isKnmStatusTypeWaitingCarryOut && isKnmPlanStatusConsideration))
  );
};
